export const GET_CACHED_TRANSCRIPTION = 'GET_CACHED_TRANSCRIPTION '
export const EXPIRE_CACHED_TRANSCRIPTION = 'EXPIRE_CACHED_TRANSCRIPTION'
export const GET_TRANSCRIPTION_REQUESTED = 'GET_TRANSCRIPTION_REQUESTED'
export const GET_TRANSCRIPTION_SUCCESS = 'GET_TRANSCRIPTION_SUCCESS'
export const GET_TRANSCRIPTION_FAILURE = 'GET_TRANSCRIPTION_FAILURE'
